const homeLinksInNewTabs = () => {
  const isWpHome = document.contains(document.querySelector('body.home'));
  if (isWpHome) {
    const links = document.querySelectorAll('body.home main a');
    links.forEach(link => {
      link.setAttribute('target', '_blank');
    });
  }
};

export default homeLinksInNewTabs;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/homeLinksInNewTabs.js